import React from 'react';
import { Box, Typography } from '@mui/material';

const VideoPlayer = ({ url, title, type = 'video' }) => {
  if (!url) {
    return (
      <Typography variant="body2" color="text.secondary">
        No recording available
      </Typography>
    );
  }

  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      {title && (
        <Typography variant="subtitle2" gutterBottom>
          {title}
        </Typography>
      )}
      {type === 'video' ? (
        <video
          controls
          style={{
            width: '100%',
            maxHeight: '400px',
            backgroundColor: '#000',
            borderRadius: '4px',
          }}
        >
          <source src={url} type="video/webm" />
          <source src={url} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <audio
          controls
          style={{
            width: '100%',
          }}
        >
          <source src={url} type="audio/webm" />
          <source src={url} type="audio/mp3" />
          Your browser does not support the audio tag.
        </audio>
      )}
    </Box>
  );
};

export default VideoPlayer;
